import { supabase } from './supabase';
import { addDays, mskToday } from './alerts';

export const TASK_CATS = ['Команда', 'Клиент', 'Актуализация инфы', 'Сбор инфы', 'Другое'];
export const CAT_STYLE = {
  'Актуализация инфы': ['#E8F1FA', '#1A4F85'], 'Сбор инфы': ['#EAF6EF', '#1F5C3A'],
  'Клиент': ['#F1E8FA', '#5A2E86'], 'Команда': ['#FFF3D6', '#7A5200'],
};
export const catStyle = (c) => CAT_STYLE[c] || ['#EEF1F7', '#33415C'];

const MON = ['янв', 'фев', 'мар', 'апр', 'мая', 'июн', 'июл', 'авг', 'сен', 'окт', 'ноя', 'дек'];
const DOW = ['вс', 'пн', 'вт', 'ср', 'чт', 'пт', 'сб'];
const dowOf = (iso) => new Date(Date.UTC(+iso.slice(0, 4), +iso.slice(5, 7) - 1, +iso.slice(8, 10))).getUTCDay();
export const fmtDate = (iso) => iso ? `${+iso.slice(8, 10)} ${MON[+iso.slice(5, 7) - 1]}, ${DOW[dowOf(iso)]}` : '';
export const fmtDateShort = (iso) => iso ? `${+iso.slice(8, 10)} ${MON[+iso.slice(5, 7) - 1]}` : '';
export const fmtTs = (ts) => {
  if (!ts) return '';
  const d = new Date(ts);
  const s = d.toLocaleString('ru-RU', { timeZone: 'Europe/Moscow', day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' });
  return s.replace('.', '');
};

// рабочие дни в (a, b]
export function workdays(a, b) {
  let n = 0, d = a;
  while (d < b) { d = addDays(d, 1); const w = dowOf(d); if (w !== 0 && w !== 6) n++; }
  return n;
}
function nthWorkday(from, k) {
  let n = 0, d = from;
  while (n < k) { d = addDays(d, 1); const w = dowOf(d); if (w !== 0 && w !== 6) n++; }
  return d;
}
// Напоминания: срок > 2 рабочих дней → промежуточное (середина) + финальное (в день дедлайна)
export function reminderDates(t) {
  const total = workdays(t.created_on, t.deadline);
  const fin = t.deadline;
  const mid = total > 2 ? nthWorkday(t.created_on, Math.ceil(total / 2)) : null;
  return { mid, fin, total };
}

// ── ссылка на задачу ─────────────────────────────────────────────────────────
export const taskLink = (id) => `${window.location.origin}/#/task/${id}`;
export function hashTaskId() {
  const m = /^#\/task\/([0-9a-f-]{36})/i.exec(window.location.hash || '');
  return m ? m[1] : null;
}
export function setTaskHash(id) {
  try { window.history.replaceState(null, '', id ? `#/task/${id}` : window.location.pathname + window.location.search); } catch (e) {}
}

// ── статус для показа ────────────────────────────────────────────────────────
export function viewStatus(t, today = mskToday()) {
  if (t.status === 'done') return 'Подтверждена';
  if (t.status === 'review') return 'На подтверждении';
  if (t.deadline < today) return 'Просрочена';
  return t.started_at ? 'В работе' : 'Новая';
}
export const ST_STYLE = {
  'Новая': ['#E8F1FA', '#1A4F85'], 'В работе': ['#FFF3D6', '#7A5200'], 'Просрочена': ['#FDECEA', '#B3261E'],
  'На подтверждении': ['#E8F1FA', '#1A4F85'], 'Подтверждена': ['#EAF6EF', '#1F7A44'],
};
export function leftText(t, today = mskToday()) {
  if (t.status === 'done') return '';
  const diff = t.deadline < today ? -workdays(t.deadline, today) : workdays(today, t.deadline);
  if (t.deadline === today) return 'сегодня';
  if (diff < 0) return `просрочено на ${-diff} раб. дн.`;
  return `${diff} раб. дн.`;
}

// ── загрузка ─────────────────────────────────────────────────────────────────
export async function loadMyTasks(userId) {
  const [a, b, c] = await Promise.all([
    supabase.from('tasks').select('*').eq('assignee_id', userId),
    supabase.from('tasks').select('*').eq('author_id', userId),
    supabase.from('task_subs').select('task_id').eq('user_id', userId),
  ]);
  if (a.error) throw a.error; if (b.error) throw b.error; if (c.error) throw c.error;
  const map = new Map();
  [...(a.data || []), ...(b.data || [])].forEach(t => map.set(t.id, t));
  const extra = (c.data || []).map(x => x.task_id).filter(id => !map.has(id));
  if (extra.length) {
    const { data, error } = await supabase.from('tasks').select('*').in('id', extra);
    if (error) throw error;
    (data || []).forEach(t => map.set(t.id, t));
  }
  const tasks = [...map.values()];
  let subs = [];
  if (tasks.length) {
    const ids = tasks.map(t => t.id);
    for (let i = 0; i < ids.length; i += 100) {
      const { data, error } = await supabase.from('task_subs').select('*').in('task_id', ids.slice(i, i + 100));
      if (error) throw error;
      subs = subs.concat(data || []);
    }
  }
  return { tasks, subs };
}

export async function loadTaskDetail(taskId, userId) {
  const { data: t, error } = await supabase.from('tasks').select('*').eq('id', taskId).maybeSingle();
  if (error) throw error;
  if (!t) return { task: null };
  const [s, c, h] = await Promise.all([
    supabase.from('task_subs').select('*').eq('task_id', taskId).order('created_at'),
    supabase.from('task_comments').select('*').eq('task_id', taskId).order('created_at'),
    supabase.from('task_history').select('*').eq('task_id', taskId).order('created_at'),
  ]);
  const subs = s.data || [];
  const allowed = t.author_id === userId || t.assignee_id === userId || subs.some(x => x.user_id === userId);
  if (!allowed) return { task: null, denied: true };
  return { task: t, subs, comments: c.data || [], history: h.data || [] };
}

// Число задач для значка в меню: мне назначено (в работе) + ждут моего подтверждения
export async function countMyOpen(userId) {
  try {
    const { tasks, subs } = await loadMyTasks(userId);
    return tasks.filter(t => isActiveForMe(t, subs, userId)).length;
  } catch (e) { return 0; }
}
export function isActiveForMe(t, subs, userId) {
  if (t.archived_at) return false;
  if (t.author_id === userId && t.status === 'review') return true;
  if (t.assignee_id === userId && t.status === 'open') return true;
  const s = subs.find(x => x.task_id === t.id && x.user_id === userId);
  return !!(s && s.status !== 'done' && t.status === 'open');
}

// ── получатели ───────────────────────────────────────────────────────────────
export async function loadTms() {
  const { data, error } = await supabase.from('users').select('id, full_name').eq('role', 'tm').eq('is_active', true).order('full_name');
  if (error) throw error;
  return data || [];
}
export async function loadSvUsers(tmId) {
  let q = supabase.from('users').select('id, full_name, tm_id').eq('role', 'sv').eq('is_active', true).order('full_name');
  if (tmId) q = q.eq('tm_id', tmId);
  const { data, error } = await q;
  if (error) throw error;
  return data || [];
}

// ── действия ─────────────────────────────────────────────────────────────────
async function hist(taskId, userId, text) {
  await supabase.from('task_history').insert({ task_id: taskId, user_id: userId, text });
}

export async function createTasks({ user, recipients, title, description, category, link, urgent, repeat_weekly, deadline }) {
  const group_id = crypto.randomUUID ? crypto.randomUUID() : null;
  const rows = recipients.map(r => ({
    group_id, title: title.trim(), description: (description || '').trim() || null,
    category, link: (link || '').trim() || null, urgent: !!urgent, repeat_weekly: !!repeat_weekly,
    deadline, created_on: mskToday(),
    author_id: user.id, author_name: user.full_name, author_role: user.role,
    assignee_id: r.id, assignee_name: r.full_name, assignee_role: r.role,
  }));
  const { data, error } = await supabase.from('tasks').insert(rows).select();
  if (error) throw error;
  await Promise.all((data || []).map(t => hist(t.id, user.id, `${roleName(user.role)} ${user.full_name} назначил задачу: ${t.assignee_name}`)));
  return data || [];
}

export const roleName = (r) => ({ rm: 'РМ', tm: 'ТМ', sv: 'СВ' }[r] || r);

// Первый просмотр исполнителем
export async function markOpened(task, subs, user) {
  const now = new Date().toISOString();
  if (task.assignee_id === user.id && !task.opened_at && task.status === 'open') {
    await supabase.from('tasks').update({ opened_at: now }).eq('id', task.id);
    await hist(task.id, user.id, `${roleName(user.role)} ${user.full_name} открыл(а) задачу`);
    return true;
  }
  const s = (subs || []).find(x => x.user_id === user.id);
  if (s && !s.opened_at) {
    await supabase.from('task_subs').update({ opened_at: now }).eq('id', s.id);
    return true;
  }
  return false;
}

// Кнопка «Приступить»: только после неё статус «В работе»
export async function startTask(task, user) {
  const now = new Date().toISOString();
  if (task.assignee_id === user.id) {
    const { error } = await supabase.from('tasks').update({ started_at: now, updated_at: now }).eq('id', task.id);
    if (error) throw error;
  } else {
    const { error } = await supabase.from('task_subs').update({ status: 'in_work', opened_at: now }).eq('task_id', task.id).eq('user_id', user.id);
    if (error) throw error;
  }
  await hist(task.id, user.id, `${roleName(user.role)} ${user.full_name} приступил(а) к задаче`);
}

// Архив постановщика: задача пропадает из активных списков у всех
export async function archiveTask(task, user, on = true) {
  const now = new Date().toISOString();
  const { error } = await supabase.from('tasks').update({ archived_at: on ? now : null, updated_at: now }).eq('id', task.id);
  if (error) throw error;
  await hist(task.id, user.id, on ? `${roleName(user.role)} ${user.full_name} убрал(а) задачу в архив` : `${roleName(user.role)} ${user.full_name} вернул(а) задачу из архива`);
}

export async function reassign(task, users, byUser) {
  if (!users.length) return;
  const rows = users.map(u => ({ task_id: task.id, user_id: u.id, user_name: u.full_name, assigned_by: byUser.id }));
  const { error } = await supabase.from('task_subs').upsert(rows, { onConflict: 'task_id,user_id', ignoreDuplicates: true });
  if (error) throw error;
  await hist(task.id, byUser.id, `Переназначено на ${users.map(u => `СВ ${u.full_name}`).join(', ')}`);
}

export async function markDone(task, user, result) {
  const now = new Date().toISOString();
  const res = (result || '').trim() || null;
  if (task.assignee_id === user.id) {
    const { error } = await supabase.from('tasks').update({ status: 'review', result: res, done_at: now, updated_at: now }).eq('id', task.id);
    if (error) throw error;
    await hist(task.id, user.id, `${roleName(user.role)} ${user.full_name} отметил(а) «Выполнено» — на подтверждении`);
  } else {
    const { error } = await supabase.from('task_subs').update({ status: 'done', done_at: now, result: res }).eq('task_id', task.id).eq('user_id', user.id);
    if (error) throw error;
    await hist(task.id, user.id, `СВ ${user.full_name} отметил(а) «Выполнено»`);
  }
}

export async function confirmTask(task, user) {
  const now = new Date().toISOString();
  const { error } = await supabase.from('tasks').update({ status: 'done', confirmed_at: now, updated_at: now }).eq('id', task.id);
  if (error) throw error;
  await hist(task.id, user.id, `${roleName(user.role)} ${user.full_name} подтвердил(а) выполнение`);
  if (task.repeat_weekly) {
    const span = Math.max(1, Math.round((Date.UTC(+task.deadline.slice(0, 4), +task.deadline.slice(5, 7) - 1, +task.deadline.slice(8, 10)) - Date.UTC(+task.created_on.slice(0, 4), +task.created_on.slice(5, 7) - 1, +task.created_on.slice(8, 10))) / 864e5));
    const nextDl = addDays(task.deadline, 7);
    const { data } = await supabase.from('tasks').insert({
      group_id: task.group_id, title: task.title, description: task.description, category: task.category,
      link: task.link, urgent: task.urgent, repeat_weekly: true, deadline: nextDl,
      created_on: addDays(nextDl, -Math.min(span, 7)),
      author_id: task.author_id, author_name: task.author_name, author_role: task.author_role,
      assignee_id: task.assignee_id, assignee_name: task.assignee_name, assignee_role: task.assignee_role,
    }).select().single();
    if (data) await hist(data.id, user.id, 'Повторяющаяся задача: создана на следующую неделю');
  }
}

export async function returnTask(task, user, comment) {
  const now = new Date().toISOString();
  const { error } = await supabase.from('tasks').update({ status: 'open', done_at: null, updated_at: now }).eq('id', task.id);
  if (error) throw error;
  await supabase.from('task_subs').update({ status: 'in_work', done_at: null }).eq('task_id', task.id).eq('status', 'done');
  await hist(task.id, user.id, `${roleName(user.role)} ${user.full_name} вернул(а) на доработку`);
  if ((comment || '').trim()) await addComment(task.id, user, comment);
}

export async function addComment(taskId, user, body) {
  const b = (body || '').trim();
  if (!b) return;
  const { error } = await supabase.from('task_comments').insert({ task_id: taskId, user_id: user.id, user_name: user.full_name, user_role: user.role, body: b });
  if (error) throw error;
}

export async function deleteTask(task) {
  const { error } = await supabase.from('tasks').delete().eq('id', task.id);
  if (error) throw error;
}

// ── баннеры-напоминания ──────────────────────────────────────────────────────
// Для исполнителя (основного или переназначенного): финальное — в день дедлайна и после, промежуточное — в середине срока.
export function buildReminders(tasks, subs, userId, today = mskToday()) {
  const out = [];
  tasks.forEach(t => {
    if (t.status !== 'open' || t.archived_at) return;
    const mine = t.assignee_id === userId || subs.some(s => s.task_id === t.id && s.user_id === userId && s.status !== 'done');
    if (!mine) return;
    const r = reminderDates(t);
    if (t.deadline < today) out.push({ key: `${t.id}:late`, kind: 'late', task: t, text: `Просрочено: «${t.title}»` });
    else if (t.deadline === today) out.push({ key: `${t.id}:fin`, kind: 'final', task: t, text: `Сегодня дедлайн: «${t.title}»` });
    else if (r.mid && today >= r.mid) out.push({ key: `${t.id}:mid`, kind: 'mid', task: t, text: `Промежуточное напоминание: «${t.title}» · осталось ${workdays(today, t.deadline)} раб. дн.` });
  });
  return out;
}
const DIS_KEY = (uid) => `fh_task_dismissed_${uid}`;
export function getDismissed(uid) { try { return JSON.parse(localStorage.getItem(DIS_KEY(uid)) || '{}'); } catch (e) { return {}; } }
export function dismissReminder(uid, key) {
  try { const d = getDismissed(uid); d[key] = mskToday(); localStorage.setItem(DIS_KEY(uid), JSON.stringify(d)); } catch (e) {}
}
// закрытое сегодня не показываем до завтра
export const isDismissedToday = (d, key) => d[key] === mskToday();
